'use client';

import { SPARTAN_PRODUCT_HERO_BANNER_SECTION_ID } from '@/app/lcv/components/sections/spartan/products/shared/section-anchors';
import { SpartanStableViewport } from '@/app/lcv/components/sections/spartan/shared/stable-viewport';

export const SpartanProductHeroStableViewport = () => (
  <SpartanStableViewport sectionId={SPARTAN_PRODUCT_HERO_BANNER_SECTION_ID} />
);
